import { render, staticRenderFns } from "./FormattingToolbox.vue?vue&type=template&id=5512b23b&"
import script from "./FormattingToolbox.vue?vue&type=script&lang=js&"
export * from "./FormattingToolbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports